import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
//компоненты
import Header from './components/Header';
import Footer from './components/Footer';
//страницы
import Development from './pages/Development';
import Stack from './pages/Stack';
import About from './pages/About';
import Contact from './pages/Contact';
//страницы с документацией
import Company from './pages/Company';
import Policy from './pages/Policy';
import Terms from './pages/Terms';
function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="layout">
          <Header />
          <main className="container main-content">
            <Routes>
              <Route path="/" element={<Development />} />
              <Route path="/stack" element={<Stack />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/company" element={<Company />} />
              <Route path="/policy" element={<Policy />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}
export default App;